import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from "vuedraggable";
import { getCardList } from "@/api/managementCenter/specialManage";
export default {
  name: "linkMagaC",
  components: {
    draggable: draggable
  },
  props: ["childModules", "homeModules"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      rulesList: [],
      businessList: [],
      downloadList: []
    };
  },
  created: function created() {},
  computed: {},
  mounted: function mounted() {
    this.getCardData("3");
    this.getCardData("4");
    this.getCardData("5");
  },
  methods: {
    handleWidth: function handleWidth(col) {
      switch (col) {
        case 1:
          return "100%";

        case 2:
          return "50%";

        case 3:
          return "33.3%";

        case 4:
          return "25%";

        case 5:
          return "20%";

        case 6:
          return "16.6%";

        default:
          return "50%";
      }
    },
    getCardData: function getCardData(type) {
      var _this = this;

      var params = {
        type: type || ""
      };
      getCardList(params).then(function (res) {
        if (type == "3") {
          _this.rulesList = res.data.data.records;
        }

        if (type == "4") {
          _this.businessList = res.data.data.records;
        }

        if (type == "5") {
          _this.downloadList = res.data.data.records;
        }
      });
    },
    addClick: function addClick(data) {
      this.$emit("addClick", data);
    },
    ifSelected: function ifSelected(val) {
      var cardModule = this.homeModules.find(function (item) {
        return item.cardType === "LINKMAGA";
      });

      if (cardModule) {
        if (cardModule.cardModules) {
          return cardModule.cardModules.some(function (item) {
            return item.code === val.code;
          });
        }

        return false;
      }

      return false;
    }
  },
  watch: {},
  filters: {}
};